import React from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";
import { makeStyles } from "@material-ui/styles";
import { buildBlocks } from "../../../services/builder";
import { GatsbyImage } from "gatsby-plugin-image";
import Grid from "@material-ui/core/Grid/Grid";
import Link from "../../Link";
import TwitterIcon from "@material-ui/icons/Twitter";
import FacebookIcon from "@material-ui/icons/Facebook";
import EmailIcon from "@material-ui/icons/Email";
import locationData from "../../../../.brew-cache/data.json";
import GoBack from "../../GoBack";
import blogAvatar from "../../../images/blog-avatar.png";
import styles from "./styles";
import { formatDate } from "../../../helpers";

const useStyles = makeStyles((theme) => styles(theme));

export const CgbBlogPostBannerBlock = (props) => {
  const blocks = buildBlocks(
    props.innerBlocks,
    props.parentAttributes,
    props.pageContext
  );
  const classes = useStyles();
  // if( ! props.attributes.mediaUrl) return null;
  let image = null;

  // Use the gatsby image if available
  if (props.attributes.mediaUrlSharp) {
    if (props.attributes.mediaUrlSharp.childImageSharp) {
      image = (
        <GatsbyImage
          image={props.attributes.mediaUrlSharp.childImageSharp.gatsbyImageData}
          className="desktop-bg"
          alt=""
        />
      );
    } else {
      // Gifs do not have a childImageSharp
      image = (
        <img
          className="desktop-bg"
          src={props.attributes.mediaUrlSharp.publicURL}
          alt=""
        />
      );
    }
  } else {
    // This is a preview image
    image = (
      <div className="gatsby-image-wrapper desktop-bg">
        <div style={{ paddingBottom: "55%" }} />
        <img
          src={props.attributes.mediaUrl}
          alt=""
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            objectPosition: "center center",
          }}
        />
      </div>
    );
  }
  let mobileImage = null;

  // Use the gatsby image if available
  if (props.attributes.mediaUrlMobileSharp) {
    if (props.attributes.mediaUrlMobileSharp.childImageSharp) {
      mobileImage = (
        <GatsbyImage
          image={
            props.attributes.mediaUrlMobileSharp.childImageSharp.gatsbyImageData
          }
          className="mobile-bg"
          alt=""
        />
      );
    } else {
      // Gifs do not have a childImageSharp
      mobileImage = (
        <img
          className="mobile-bg"
          src={props.attributes.mediaUrlMobileSharp.publicURL}
          alt=""
        />
      );
    }
  } else {
    // This is a preview image
    mobileImage = (
      <div className="gatsby-image-wrapper mobile-bg">
        <div style={{ paddingBottom: "55%" }} />
        <img
          src={props.attributes.mediaUrlMobile}
          alt=""
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            objectPosition: "center center",
          }}
        />
      </div>
    );
  }

  let postDate = props.pageContext.date;

  return (
    <>
      <div
        className={`banner-message ${
          props.attributes.className ? props.attributes.className : ""
        } ${classes.blogBanner} ${classes.blogBannerTheme}`}
      >
        <GoBack fallback="/latest" />
        {image}
        {mobileImage}
        <p className="date desktop">{formatDate(postDate)}</p>
        <div className="banner-meta">
          <p className="date mobile">{formatDate(postDate)}</p>
          {blocks.map((block) => {
            return block;
          })}
        </div>
      </div>
      <div className={`post-meta ${classes.blogPostMeta}`}>
        <Grid container spacing={3} direction="row">
          <Grid item xs={12} md={6}>
            <div className="social-sharing">
              <p className="title">Share this news</p>
              <p className="link-list">
                <Link
                  to={
                    "https://twitter.com/intent/tweet?text=" +
                    props.pageContext.pageTitle +
                    "&url=" +
                    locationData.url +
                    props.pageContext.pagePath
                  }
                >
                  <TwitterIcon />
                </Link>
                <Link
                  to={
                    "https://www.facebook.com/sharer/sharer.php?u=" +
                    locationData.url +
                    props.pageContext.pagePath
                  }
                >
                  <FacebookIcon />
                </Link>
                <Link
                  to={
                    "mailto:?subject=" +
                    props.pageContext.pageTitle +
                    "&amp;body=" +
                    locationData.url +
                    props.pageContext.pagePath
                  }
                >
                  <EmailIcon />
                </Link>
              </p>
            </div>
          </Grid>
          <Grid item xs={12} md={6}>
            <div className="author">
              <img src={blogAvatar} alt="" className="icon" />
              <p>
                <span>Written by </span>
                {props.pageContext.author}
              </p>
            </div>
          </Grid>
        </Grid>
      </div>
    </>
  );
};

CgbBlogPostBannerBlock.propTypes = {
  attributes: PropTypes.object.isRequired,
};

export const CgbBlogPostBannerBlockFragment = graphql`
  fragment CgbBlogPostBannerBlock on WpBlock {
    ... on WpCgbBlogPostBannerBlock {
      name
      attributes {
        __typename
        ... on WpCgbBlogPostBannerBlockAttributes {
          className
          mediaUrl
          mediaUrlMobile
          mediaUrlSharp {
            id
            publicURL
            childImageSharp {
              gatsbyImageData(
                width: 1440
                placeholder: BLURRED
                formats: [AUTO, WEBP]
                transformOptions: { fit: COVER, cropFocus: CENTER }
              )
            }
          }
          mediaUrlMobileSharp {
            id
            publicURL
            childImageSharp {
              gatsbyImageData(
                width: 960
                placeholder: BLURRED
                formats: [AUTO, WEBP]
                transformOptions: { fit: COVER, cropFocus: CENTER }
              )
            }
          }
        }
      }
    }
  }
`;

// This is the string version of this that is used within previews and without WP prefixes
export const CgbBlogPostBannerBlockPreview = `
    ... on CgbBlogPostBannerBlock {
        name
        attributes {
            __typename
            ... on CgbBlogPostBannerBlockAttributes {
                className
                mediaUrl
                mediaUrlMobile
            }
        }
    }
`;
